import molin_8 from '../../assets/images/tra/molin_8.webp';
import MolinHeader from '../../components/MolinHeader';
import { useState } from 'react';
import '../../styles/common.css'
export default function FriendOfXiang() {
    const [storyStatus, setStoryStatus] = useState(0);
    const [introductionStatus, setIntroductionStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>
            <img src={molin_8} alt="Hero background" className="w-full h-auto" />
            <div className='absolute bottom-[28%] left-[32%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                <div className="flex flex-col text-center font-bold">
                    <span className="text-[#000000] text-[1vw]">项元汴</span>
                    <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                </div>
            </div>
            <div className='absolute bottom-[34%] left-[48%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                <div className="flex flex-col text-center font-bold">
                    <span className="text-[#000000] text-[0.8vw]">安国后人 安南屏</span>
                    <span className="text-[#000000] text-[0.6vw]">Anguo's descendant, An Nanping</span>
                </div>
            </div>
            {introductionStatus === 0 && (
                <div className="bottom-[32%] left-[48%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setIntroductionStatus(1)}>
                    </button>
                </div>
            )}

            {storyStatus === 0 && (
                <div className="bottom-[48%] left-[54%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(1)}>
                    </button>
                </div>
            )}
            {storyStatus === 1 && (
                <div className="top-[40%] left-[42%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(2)}>
                    </button>
                </div>
            )}
            {introductionStatus >= 1 && (
                <div className={`chat-bubble-base absolute bottom-[10%] left-[98%] transform -translate-x-1/2
                    chat-bubble-fade-in ${introductionStatus >= 1 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='text-center mt-[0.5vw] typing-effect'>与友人进行书画交易</span>
                    <span className='text-center mt-[0.2vw]  typing-effect'>
                    项元汴的藏品中有一部分是来自与友人进行书画交易。其中例如：项元汴曾从安国手里购得王羲之的《每思帖》，</span>
                    <span className='text-center typing-effect'>“墨林主人项元汴用价五十金得于无锡安氏，时隆庆三年八月朔日。”</span>
                    <span className='text-center my-[0.2vw] typing-effect'>Art Transactions with Friends</span>
                    <span className='text-center typing-effect'>A portion of Xiang Yuanbian’s collection was acquired through art transactions with friends. For example, he once purchased Wang Xizhi’s</span>
                    <span className='text-center typing-effect'>Mei Si Tie (Letter on Constant Thoughts) from An Guo. As recorded:"Master Xiang Yuanbian of Molin Hall acquired it from the An family</span>
                    <span className='text-center mb-[0.5vw] typing-effect'>of Wuxi for fifty taels of silver on the first day of the eighth month in the third year of the Longqing era (1569)."</span>
                </div>
            )}
            {storyStatus >= 1 && (
                <div className={`chat-bubble-base absolute top-[25%] left-[91%] transform -translate-x-1/2 chat-bubble-left
                    chat-bubble-fade-in ${storyStatus >= 1 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“听闻项先生钟意此卷已久，先祖生前叮嘱，此类名迹须得遇真知音。今日一并相赠于您。”</span>
                    <span className='typing-effect'>"I've heard that Master Xiang has long cherished this scroll. My ancestors, before their passing, instructed that such </span>
                    <span className='mb-[1vw] typing-effect'>masterpieces must find a true connoisseur. Today, I shall present this to you."</span>

                </div>
            )}
            {storyStatus >= 2 && (
                <div className={`chat-bubble-base absolute top-[22%] left-[40%] transform -translate-x-1/2 chat-bubble-right 
                    chat-bubble-fade-in ${storyStatus >= 2 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“安先生所言极是，墨林购藏非为私赏，皆愿与天下文人共鉴。”</span>
                    <span className='typing-effect'>"Mr. An, your words are most wise. The acquisitions of Molin Hall are not made </span>
                    <span className='mb-[1vw] typing-effect'>for private appreciation; I wish to share these treasures with all scholars across the world."</span>
                </div>
            )}
        </div>
    )
}